<template>
  <div class="custom-instructions">
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col class="content">
          <div style="min-height:100px;">
            <html-content :content="data['custom_instruction']" :allow-magnifying-image="true"/>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <preview-edit-link
        :path_params="'&active_panel=settings&msg=instruction_anchor#instruction'">
      Edit custom instructions
    </preview-edit-link>
  </div>
</template>

<script setup>
import { onMounted, reactive } from 'vue';
import { useStore } from 'vuex';
import { IonCol, IonGrid, IonRow } from '@ionic/vue';
import HtmlContent from '@/components/html/HtmlContent.vue';
import PreviewEditLink from "@/components/html/PreviewEditLink.vue";

const emit = defineEmits([
  'complete',
]);

const store = useStore();
const data = reactive(store.state.Test.data['test_intro']);
const settings = reactive(store.state.Test.settings['test']);

onMounted(() => {
  emit('complete');
});
</script>

<style lang="scss" scoped>
//@import '@/theme/variables';
.custom-instructions {

  .content {
    overflow-x: auto;
    background-color: variables.$color-white;
    border-radius: variables.$default-border-radius;
    margin: 0 0 0px;
  }
}
</style>